import * as React from 'react';
import { Button } from 'antd';
import { HeartFilled } from '@ant-design/icons';
import { displayTime, randomInt } from '../functions';
import UserContext from '../../contexts/UserContext';
import { tileConfig, boardConfig, gameConfig } from './config';
import { ChimpTestBox, GameBoard, StartButtonBox, SingleTile, GameOverBox, GameOverInfo, GameOverInfoText, ChipTextInfoHeader } from './ChimpTest.css';
import { GameOverAnimation, HeartBox, LivesBox } from '../VisualMemory/VisualMemory.css';
import { GameOverButton, GameOverInfoBox, GameOverRow, InfoBarBox, LevelBox } from '../SequenceMemory/SequenceMemory.css';
import ShowTime from '../../components/components/ShowTime/ShowTime';
import gamesList from '../../components/components/ChooseGame/gamesList';
import { saveUserRecord } from '../api';

const { useState, useContext } = React;

interface ITile {
    id: number;
    text: number;
    x: number;
    y: number;
    hidden: boolean;
    visible: boolean;
}

interface Axis {
    x: number;
    y: number;
    height: number;
    width: number;
}

const ChimpTest = () => {
    const {user} = useContext(UserContext);
    const [gameStarted, setGameStarted] = useState(false);
    const [gameOver, setGameOver] = useState(false);
    const [level, setLevel] = useState(0);
    const [hideTiles, setHideTiles] = useState(false);
    const [tiles, setTiles] = useState<ITile[]>([]);
    const [lives, setLives] = useState(3);
    const [correctClicks, setCorrectClicks] = useState<boolean[]>([]);
    const [startTime, setStartTime] = useState(0);
    const [gameTime, setGameTime] = useState(0);
    const [scoreSaved, setScoreSaved] = useState(false);

    const isCollide = (a:Axis, b:Axis) => {
        return !(
            ((a.y + a.height) < (b.y)) ||
            (a.y > (b.y + b.height)) ||
            ((a.x + a.width) < b.x) ||
            (a.x > (b.x + b.width))
        );
    }

    const isCorrectXY = (x: number, y: number, newTiles: ITile[]) => {
        for (let i = 0; i < newTiles.length; i++) {
            const tile = newTiles[i];
            const a = {
                x, y,
                width: tileConfig.width,
                height: tileConfig.height,
            };
            const b = {
                x: tile.x,
                y: tile.y,
                width: tileConfig.width,
                height: tileConfig.height,
            };
            if(isCollide(a, b)) {
                return false;
            }
        }
        return true;
    };

    const isCorrectY = (y: number) => {
        return true;
    };

    const getRandX = () => {
        return randomInt(0, boardConfig.width - tileConfig.width - boardConfig.padding);
    };

    const getRandY = () => {
        return randomInt(0, boardConfig.height - tileConfig.height - boardConfig.padding);
    };

    const getAxis = (newTiles: ITile[]): { x: number, y: number } => {

        let x = getRandX();
        let y = getRandY();

        let attempt = 9999;

        while (!isCorrectXY(x, y, newTiles)) {
            console.log('not correct');
            if (attempt <= 0) break;
            x = getRandX();
            y = getRandY();
            attempt--;
        }

        return { x, y };
    }

    const createNewLevel = (lev?: number) => {
        setHideTiles(false);
        setCorrectClicks([]);
        const currLevel = (lev !== undefined && lev >=0) ? lev : level;
        console.log(currLevel);
        const newLevel = currLevel + 1;
        const countTiles = newLevel + gameConfig.tileCount;
        const newTiles: ITile[] = [];
        for (let i = 0; i < countTiles; i++) {
            const axis = getAxis(newTiles);
            newTiles.push({
                id: i,
                text: i + 1,
                x: axis.x,
                y: axis.y,
                hidden: false,
                visible: true,
            })
        }
        setGameTime(Date.now() - startTime);
        setLevel(newLevel);
        setTiles(newTiles);
    };

    const handlePlayAgain = () => {
        setGameOver(false);
        setLives(3);
        createNewLevel(0);
    };

    const handleStartGame = () => {
        setStartTime(Date.now());
        setGameStarted(true);
        createNewLevel();
    };

    const renderLives = () => {
        const tlives = [];
        for (let i = 0; i < lives; i++) {
            tlives.push(1)
        }
        return <HeartBox>
            {tlives.length > 0 && tlives.map( x => <HeartFilled />)}
        </HeartBox>
    }

    const handleClickTile = (index: number) => {
        if (!gameStarted || gameOver) return;
        if (correctClicks.length === tiles[index].id) {
            if (correctClicks.length === 0 && level > 1) {
                setHideTiles(true);
            }
            const newArr = [...correctClicks];
            newArr.push(true);
            setCorrectClicks(newArr);
            const newTiles = [...tiles];
            newTiles[index].visible = false;
            setTiles(newTiles);
            console.log(correctClicks.length, level + gameConfig.tileCount);
            if (correctClicks.length >= level + gameConfig.tileCount - 1) {
                createNewLevel();
            }
        } else {
            if (lives <= 1) {
                setGameOver(true);
                console.log('game over');
            } else {
                setLives(lives-1);
                createNewLevel(level-1);
            }
        }
    }

    const renderTile = (tile: ITile, i: number) => {
        return <SingleTile onClick={() => handleClickTile(i)} x={tile.x} y={tile.y} hid={hideTiles} visib={tile.visible}>{!hideTiles && tile.text}</SingleTile>;
    };

    const saveScore = async () => {
        const gameId = gamesList.find(x => x.id === 'ct')?.gameId || 0;
        const saved = await saveUserRecord(user.id, level, gameTime, gameId);
        setScoreSaved(true);
        console.log(saved);
    };

    return (
        <ChimpTestBox>
            {!gameStarted && <StartButtonBox>
                <Button onClick={handleStartGame}>START</Button>
            </StartButtonBox>}
            <InfoBarBox style={{height: 38}}>
                <LevelBox>
                    LEVEL {level}
                </LevelBox>
                { // gameTime === 0 && <Timer interval={100} timeStart={startTime} />
                }
                <LivesBox>
                    {renderLives()}
                </LivesBox>
            </InfoBarBox>
            {gameOver && <GameOverAnimation>
                <GameOverInfoBox>
                    <GameOverRow>
                        LEVEL {level}
                    </GameOverRow>
                    <GameOverRow>
                        <ShowTime time={displayTime(gameTime)} sufix='s' margin={-1} />
                    </GameOverRow>
                    <GameOverButton>
                        <Button onClick={handlePlayAgain}>PLAY AGAIN</Button>
                        <Button disabled={scoreSaved} style={{marginLeft: 5}} onClick={saveScore}>{scoreSaved ? 'SAVED' : 'SAVE SCORE'}</Button>
                    </GameOverButton>
                </GameOverInfoBox>
            </GameOverAnimation>}
            <GameBoard>
                {
                    (gameStarted && tiles.length) && tiles.map(renderTile)
                }
            </GameBoard>
        </ChimpTestBox>
    );
};

export default ChimpTest;